import { TableItem } from 'components/atoms';
import { ReactNode } from 'react';

interface ITableRowItemListProps<T> {
  items: T[];
  children: (value: T, index: number, array: T[]) => ReactNode;
  maxLength?: number;
}

const TableRowItemList = <T,>({
  items,
  maxLength = 3,
  children,
}: ITableRowItemListProps<T>) => {
  const listedItems =
    items.length > maxLength
      ? items.filter((_, index) => index + 2 <= maxLength)
      : items;

  return (
    <>
      {listedItems.length ? listedItems.map(children) : '-'}
      {items.length > maxLength && (
        <TableItem.Text
          isSupplementary
          text={`+ ${items.length - maxLength + 1}`}
        />
      )}
    </>
  );
};

export default TableRowItemList;
